import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Badge, Col, Dropdown, ListGroup, Media, Nav, Navbar, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import layoutHelpers from './helpers'

import _ from 'lodash'
import styled from 'styled-components'
import { isEmpty, time_from_now } from '../../Utils'
import IntlMessages from '../../Utils/IntlMessages'
import BurgerIcon from '../../components/icons/BurgerIcon'
import { apiClient } from '../../services/api'
import { setLanguage } from '../../store/actions/themeActions'
import { useAuth } from '../hooks/useAuth'
import HamburgerArrowRightSvg from './SideNav/assets/HamburgerArrowRightSvg'
import HamburgerBarLeftSvg from './SideNav/assets/HamburgerBarLeftSvg'


const LANGUAGE = [
  {id: 'TH', locale: 'th-TH', title: 'THAI'},
  {id: 'EN', locale: 'en-US', title: 'ENGLISH'},
]
const LayoutNavbarHoc = props => {
  // console.log('bbbbb', props)
  const { logout, changeRole } = useAuth()

  return <LayoutNavbar {...props} doLogout={logout} changeRole={changeRole} />
}

class LayoutNavbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isToggle: false,
      languageList: LANGUAGE,
      selectedLanguage: LANGUAGE[0],
      notifications: [],
      stdImage:
        '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',
    }

    this.isRTL = document.documentElement.getAttribute('dir') === 'rtl'
  }

  async componentDidMount() {
    // console.log(this.props)
    let selectedLanguage = LANGUAGE.find(lang => lang.locale === this.props.locale)
    // console.log('selectedLanguage is ', selectedLanguage)
    if (selectedLanguage) {
      this.setState({ selectedLanguage })
    }

    if (!isEmpty(this.props.user.student) && this.props.user?.userType === '1') {
      //await this.updateNotifications()
      this.updateNotificationsFromLocalStore()
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  getSelectedRole = () => {
    return this.props.user?.roles.find(item => item.roleId == this.props.user.currentRole)
  }

    onChangeLanguage = id => {
    let { languageList } = this.state
    let selectedLanguage = languageList.find(lang => lang.id === id)
    console.log('selectedLanguage is ', selectedLanguage)
    if (selectedLanguage) {
      this.setState({ selectedLanguage })
    }
    //redux action
    this.props.setLanguage(selectedLanguage.locale)
    console.log('change language action', selectedLanguage)
  }

  toggleNotifications(event) {
    if (event) {
      this.updateNotifications()
    }
  }

  updateNotificationsFromLocalStore() {
    try {
      let cacheNoti = localStorage.getItem('notification' + this.props.user.student.stdId)
      // JSON.parse(cacheNoti)
      if (cacheNoti) {
        console.log('Local noti found.')
        this.setState({ notifications: JSON.parse(cacheNoti) })
      } else {
        console.log('no cache noti found.')
        this.updateNotifications()
      }
    } catch (e) {
      console.error(e)
    }
  }

  updateNotifications = async () => {
    let notifications = []
    let stdId = this.props.user.student.stdId
    let caching = 0
    let params = { stdId, caching }

    // await trackPromise(
    apiClient
      .get('/advisor/getStdContact', { params })
      .then(res => {
        if (res.data.code === 'success') {
          notifications = _.sortBy(res.data.results, ['updated_dt']).reverse()
          console.log('noti', notifications)
          localStorage.setItem('notification' + stdId, JSON.stringify(notifications))
          this.setState({ notifications })
        } else {
          //keep empty to local
          localStorage.setItem('notification' + stdId, JSON.stringify([]))
          console.log('not success', res)
        }
      })
      .catch(err => console.log(err)) //,
    // )
  }

  genNotiHeading(type) {
    if (type === 'PROB') {
    } else if (type === 'ENROLL') {
      return ''
    } else {
      return ''
    }
  }

  genUserFullName() {
    const { user, locale } = this.props
    if (user?.userType === '1') {
      if (user.student.nationCode === 'TH') {
        if (locale === 'th-TH') {
          return `${user.idCode || ''} ${user.titleTh || ''} ${user.firstNameTh || ''} ${user.student.middleNameTh || ''} ${user.lastNameTh || ''}`
        } else {
          return `${user.idCode || ''} ${user.titleEn || ''} ${user.firstNameEn || ''} ${user.student.middleNameEn || ''} ${user.lastNameEn || ''}`
        }
      } else {
        if (locale === 'th-TH') {
          return `${user.idCode || ''} ${user.titleEn || ''} ${user.firstNameEn || ''} ${user.student.middleNameEn || ''} ${user.lastNameEn || ''}`
        } else {
          return `${user.idCode || ''} ${user.titleEn || ''} ${user.firstNameEn || ''} ${user.student.middleNameEn || ''} ${user.lastNameEn || ''}`
        }
      }
    } else {
      if (locale === 'th-TH') {
        return `${user.idCode || ''} ${user.titleTh || ''} ${user.firstNameTh || ''} ${user.lastNameTh || ''}`
      } else {
        return `${user.idCode || ''} ${user.titleEn || ''} ${user.firstNameEn || ''} ${user.lastNameEn || ''}`
      }
    }
  }

  renderNotificationMobile() {
    const { notifications } = this.state
    const notificationsQty = _.size(notifications)

    return (
      <div>
        <Dropdown.Menu alignRight={false} style={{ minWidth: 300, maxHeight: '70vh', overflowY: 'scroll' }}>
          <div className="bg-primary text-center text-white font-weight-bold p-3">
            {notificationsQty > 0 ? `${notificationsQty} การแจ้งเตือนใหม่` : `ไม่มีการแจ้งเตือนใหม่`}
          </div>
          <ListGroup variant="flush">
            {notificationsQty > 0 &&
              notifications.map((notification, index) => {
                return (
                  <ListGroup.Item as={Media} key={index} action className="d-flex align-items-center">
                    <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-home bg-secondary border-0 text-white"></div>
                    <Media.Body className="line-height-condenced ml-3">
                      <div className="text-body">{this.genNotiHeading(notification.contact_type)}</div>
                      <div className="small mt-1">{notification.message}</div>
                      <div className="text-light small mt-1">{time_from_now(notification.updated_dt)}</div>
                    </Media.Body>
                  </ListGroup.Item>
                )
              })}
          </ListGroup>
        </Dropdown.Menu>
      </div>
    )
  }

  renderNotification() {
    const { notifications } = this.state
    const notificationsQty = _.size(notifications)

    return (
      <Dropdown.Menu alignRight={false} style={{ minWidth: 300, maxHeight: '70vh', overflowY: 'scroll' }}>
        <div className="bg-primary text-center text-white font-weight-bold p-3">
          {notificationsQty > 0 ? `${notificationsQty} การแจ้งเตือนใหม่` : `ไม่มีการแจ้งเตือนใหม่`}
        </div>
        <ListGroup variant="flush">
          {notificationsQty > 0 &&
            notifications.map((notification, index) => {
              return (
                <ListGroup.Item as={Media} key={index} action className="d-flex align-items-center">
                  <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-home bg-secondary border-0 text-white"></div>
                  <Media.Body className="line-height-condenced ml-3">
                    <div className="text-body">{this.genNotiHeading(notification.contact_type)}</div>
                    <div className="small mt-1">{notification.message}</div>
                    <div className="text-light small mt-1">{time_from_now(notification.updated_dt)}</div>
                  </Media.Body>
                </ListGroup.Item>
              )
            })}

          {/* <ListGroup.Item as={Media} action className="d-flex align-items-center">
                     <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-home bg-secondary border-0 text-white"></div>
                     <Media.Body className="line-height-condenced ml-3">
                     <div className="text-body">แจ้งเตือนจากอาจารย์ที่ปรึกษา</div>
                     <div className="small mt-1">
                     อาจารย์ที่ปรึกษาให้เข้าพบ วันจันทร์ที่ 15 พ.ค. 2563.
                     </div>
                     <div className="text-light small mt-1">12h ago</div>
                     </Media.Body>
                     </ListGroup.Item>

                     <ListGroup.Item as={Media} action className="d-flex align-items-center">
                     <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-person-add bg-info border-0 text-white"></div>
                     <Media.Body className="line-height-condenced ml-3">
                     <div className="text-body">แจ้งเตือนจากอาจารย์ที่ประจำวิชา</div>
                     <div className="small mt-1">
                     รายวิขา 01345111-51 เปลี่ยนแปลงห้องเรียนเป็น ศร 102.
                     </div>
                     </Media.Body>
                     </ListGroup.Item>

                     <ListGroup.Item as={Media} action className="d-flex align-items-center">
                     <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-power bg-danger border-0 text-white"></div>
                     <Media.Body className="line-height-condenced ml-3">
                     <div className="text-body">Server restarted</div>
                     <div className="small mt-1">
                     19h ago
                     </div>
                     </Media.Body>
                     </ListGroup.Item>

                     <ListGroup.Item as={Media} action className="d-flex align-items-center">
                     <div className="ui-icon ui-icon-sm flex-shrink-0 ion ion-md-warning bg-warning border-0 text-body"></div>
                     <Media.Body className="line-height-condenced ml-3">
                     <div className="text-body">99% server load</div>
                     <div className="text-light small mt-1">
                     Etiam nec fringilla magna. Donec mi metus.
                     </div>
                     <div className="text-light small mt-1">
                     20h ago
                     </div>
                     </Media.Body>
                     </ListGroup.Item> */}
        </ListGroup>

        {/* <a href="#link" className="d-block text-center text-light small p-2 my-1" onClick={e => e.preventDefault()}>Show all notifications</a> */}
      </Dropdown.Menu>
    )
  }

  logoutProcess = () => {
    this.props.doLogout()
  }

  handelToggled = () => {
    this.setState({ isToggle: !this.state.isToggle })
    this.props.onToggle(!this.state.isToggle)
  }
  render() {
    let { languageList, selectedLanguage, notifications } = this.state
    const notificationsQty = _.size(notifications)

    return (
      <Navbar style={{ zIndex: 20 }} bg={this.props.navbarBg} expand="md" className="sticky-top">
        {/* Brand demo (see src/demo.css) */}
        {!this.props.user && this.props.user?.userType === '1' && (
          <Navbar.Brand as={NavLink} to="/std/profile" className="app-brand demo d-lg-none py-0 mr-3">
            <span className="app-brand-logo demo" style={{ backgroundColor: '#EEEEEE' }}>
              {/* <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stopOpacity=".25" offset="0"></stop><stop stopOpacity=".1" offset=".3"></stop><stop stopOpacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlinkHref="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlinkHref="#a"></linearGradient></defs><path style={{fill: '#fff'}} transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg> */}

              {/* <img src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`} alt="Kasetsart University" style={{width :23,height:28}} className="profile-avatar rounded-circle" /> */}
              {/* show user profile image */}

              <img src={'data:' + this.state.stdImage} alt="" style={{ width: 40 }} className="profile-avatar rounded-circle" />
            </span>
          </Navbar.Brand>
        )}
        {!this.props.user && this.props.user?.userType === '1' && (
          <Navbar.Brand as={NavLink} to="/std/profile" className="app-brand demo d-lg-none py-0 mr-3">
            <span className="app-brand-logo demo" style={{ backgroundColor: '#EEEEEE' }}>
              {/* <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stopOpacity=".25" offset="0"></stop><stop stopOpacity=".1" offset=".3"></stop><stop stopOpacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlinkHref="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlinkHref="#a"></linearGradient></defs><path style={{fill: '#fff'}} transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg> */}

              {/* <img src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`} alt="Kasetsart University" style={{width :23,height:28}} className="profile-avatar rounded-circle" /> */}
              {/* show user profile image */}
              <img
                src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
                alt="Kasetsart University"
                style={{ width: 23, height: 28, marginTop: 5 }}
                className="profile-avatar rounded-circle"
              />
            </span>
          </Navbar.Brand>
        )}
        {!this.props.user && this.props.user?.userType !== '1' && (
          <Navbar.Brand className="app-brand demo d-lg-none py-0 mr-12 ">
            <span className="app-brand-logo demo" style={{ backgroundColor: '#EEEEEE' }}>
              <img
                src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
                alt="Kasetsart University"
                style={{ width: 23, height: 28, marginTop: 5 }}
                className="profile-avatar rounded-circle"
              />
            </span>
          </Navbar.Brand>
        )}
        {/* Sidenav toggle (see src/demo.css) */}
        {/* {this.props.sidenavToggle && (
          <Nav className="layout-sidenav-toggle d-lg-none align-items-lg-center mr-3">
            <Nav.Item as="a" className="nav-link px-0 mr-lg-4" href="#toggle" onClick={this.toggleSidenav}> */}
        {/* <i className="ion ion-md-menu text-large align-middle"></i> */}
        {/* <div style={{ width: '1.5rem' }}>
                <BurgerIcon />
              </div>
            </Nav.Item>
          </Nav>
        )} */}
        <span
          className="app-brand-text layout-sidenav-toggle d-md-none align-items-lg-center ml-auto mr-auto"
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            // maxWidth: 135,
            // width: '80%',
            textAlign: 'center',
            maxWidth: '60%',
          }}
        >
          {this.props.pageTitle}
        </span>
        {/* logout mobile*/}
        {this.props.user?.roles && this.props.user?.roles.length > 1 && (
          <PowerIcon
            className="ion ion-ios-power navbar-icon align-middle d-md-none"
            onClick={() => {
              // this.props.logout()
              // this.props.history.push('/login')
              this.logoutProcess()
            }}
          />
        )}
        <div className={`cusor-pointer`} onClick={() => this.handelToggled()}>
          {this.state.isToggle ? <HamburgerArrowRightSvg /> : <HamburgerBarLeftSvg />}
        </div>
        <div className="align-items-center col-lg-6 justify-content-end d-none d-lg-block">
          <span style={{ fontSize: 16 }}>
            <IntlMessages id="COMMON__ENROLLMENT_SYSTEM_KU" />
          </span>
          <br />
          <span style={{ fontSize: 16 }}></span>
        </div>
        {/* มุมมองอะไรซักอย่างของเด็ก mobile only */}
        <>
          {this.props.user?.userType === '1' && (
            <Dropdown
              as={Nav.Item}
              onToggle={event => this.toggleNotifications(event)}
              className="demo-navbar-notifications mr-lg-3 d-md-none"
              alignRight={!this.isRTL}
            >
              <Dropdown.Toggle as={Nav.Link} className="hide-arrow" style={{ paddingLeft: 10, paddingRight: 10 }}>
                <i className="ion ion-md-notifications-outline navbar-icon align-middle" style={{ color: '#cbf1e3' }}></i>
                {notificationsQty > 0 && <Badge variant="primary badge-dot indicator"></Badge>}
                {/* <span className="d-lg-none align-middle">&nbsp; Notifications</span> */}
              </Dropdown.Toggle>

              {this.renderNotificationMobile()}
            </Dropdown>
          )}

          {(!this.props.user?.roles || this.props.user?.roles.length === 1) && (
            <>
              {/* mobile view */}
              <Dropdown className="demo-navbar-user d-md-none" alignRight={!this.isRTL}>
                <Dropdown.Toggle as={Nav.Link} style={{ color: '#cbf1e3', paddingRight: 15, paddingLeft: 10 }}>
                  <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle" style={{ color: '#cbf1e3' }}>
                    {selectedLanguage.id}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown__menu">
                  {languageList.map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => this.onChangeLanguage(item.id)} className="menu__item">
                      {item.id}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              {/* logout */}

              <PowerIcon
                className="ion ion-ios-power navbar-icon align-middle d-md-none"
                onClick={() => {
                  // this.props.logout()
                  // this.props.history.push('/login')   // "https://sso.ku.ac.th/nidp/app/logout?continue=/login"
                  this.logoutProcess()
                }}
              />
            </>
          )}
        </>
        {/*ตัวเปลี่ยน role mobile */}
        <>
          {this.props.user?.roles && this.props.user?.roles.length > 0 && (
            <div style={{ flex: 1 }} className="d-flex justify-content-end">
              {/* mobile view */}
              <div className="d-md-none">
                <Dropdown className="demo-navbar-user" alignRight={!this.isRTL}>
                  <Dropdown.Toggle as={Nav.Link} style={{ color: '#cbf1e3', paddingRight: 15, paddingLeft: 10 }}>
                    <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                      {this.props.setting.locale === 'th-TH' ? this.getSelectedRole().roleNameTh : this.getSelectedRole().roleNameEn}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown__menu" style={{ width: 'max-content' }}>
                    {this.props.user.roles.map(role => (
                      <Dropdown.Item
                        key={role.roleId}
                        onClick={() => this.props.changeRole(role.roleId)}
                        className="menu__item"
                        disabled={this.props.user?.roles.length <= 1}
                      >
                        {this.props.setting.locale === 'th-TH' ? role.roleNameTh : role.roleNameEn}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                {/* Divider */}
                <div className="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>
              </div>

              {/* mobile view */}
              <Dropdown className="demo-navbar-user d-md-none" alignRight={!this.isRTL}>
                <Dropdown.Toggle as={Nav.Link} style={{ color: '#cbf1e3', paddingRight: 15, paddingLeft: 10 }}>
                  <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle" style={{ color: '#cbf1e3' }}>
                    {selectedLanguage.id}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown__menu">
                  {languageList.map((item, index) => (
                    <Dropdown.Item key={index} onClick={() => this.onChangeLanguage(item.id)} className="menu__item">
                      {item.id}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </>
        <Row className="d-flex d-md-none d-lg-none navbar--student-name">
          <Col xs={12}>
            <div className="demo-navbar-user align-self-center mr-1">
              <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                <span className="px-1 mr-lg-2 ml-2 ml-lg-0">{this.props.user && this.genUserFullName()}</span>
              </span>
            </div>
          </Col>
        </Row>
        {/* <Navbar.Toggle /> */}
        <Navbar.Collapse>
          {/* Divider */}
          <hr className="d-md-none w-100 my-2" />
          <Nav className="align-items-lg-center ml-auto">
            {this.props.user?.userType === '1' && (
              <Dropdown
                onToggle={event => this.toggleNotifications(event)}
                as={Nav.Item}
                className="demo-navbar-notifications mr-lg-3 d-none d-md-block"
                alignRight={!this.isRTL}
              >
                <Dropdown.Toggle as={Nav.Link} className="hide-arrow">
                  <i className="ion ion-md-notifications-outline navbar-icon align-middle" style={{ color: '#cbf1e3' }}></i>
                  {notificationsQty > 0 && <Badge variant="primary badge-dot indicator"></Badge>}
                  {/* <span className="d-lg-none align-middle">&nbsp; Notifications</span> */}
                </Dropdown.Toggle>

                {this.renderNotification()}
              </Dropdown>
            )}

            {/*ตัวเปลี่ยน role desktop*/}
            <>
              {this.props.user?.roles && this.props.user?.roles.length > 0 && (
                <>
                  <Dropdown className="demo-navbar-user" alignRight={!this.isRTL}>
                    <Dropdown.Toggle as={Nav.Link} style={{ color: '#cbf1e3', paddingRight: 15, paddingLeft: 10 }}>
                      <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                        {this.props.setting.locale === 'th-TH' ? this.getSelectedRole().roleNameTh : this.getSelectedRole().roleNameEn}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown__menu" style={{ width: 'max-content' }}>
                      {this.props.user.roles.map(role => (
                        <Dropdown.Item
                          key={role.roleId}
                          onClick={() => this.props.changeRole(role.roleId)}
                          className="menu__item"
                          disabled={this.props.user?.roles.length <= 1}
                        >
                          {this.props.setting.locale === 'th-TH' ? role.roleNameTh : role.roleNameEn}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {/* Divider */}
                  <div className="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>
                </>
              )}
            </>

            <Dropdown className="demo-navbar-user" alignRight={!this.isRTL}>
              <Dropdown.Toggle as={Nav.Link}>
                <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">{selectedLanguage.id}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown__menu">
                {languageList.map((item, index) => (
                  <Dropdown.Item key={index} onClick={() => this.onChangeLanguage(item.id)} className="menu__item">
                    {item.id}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Divider */}
            <div className="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>
            {false && (
              <Dropdown as={Nav.Item} className="demo-navbar-user" alignRight={!this.isRTL}>
                <Dropdown.Toggle as={Nav.Link}>
                  <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                    <span className="px-1 mr-lg-2 ml-2 ml-lg-0">{this.props.user && this.genUserFullName()}</span>
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item hred="#">
                    <i className="ion ion-ios-person text-lightest"></i> &nbsp; My profile
                  </Dropdown.Item>
                  {/* <Dropdown.Item hred="#"><i className="ion ion-ios-mail text-lightest"></i> &nbsp; Messages</Dropdown.Item>
                                     <Dropdown.Item hred="#"><i className="ion ion-md-settings text-lightest"></i> &nbsp; Account settings</Dropdown.Item> */}
                  <Dropdown.Divider />
                  <Dropdown.Item
                    hred="#"
                    onClick={() => {
                      // this.props.logout()
                      // this.props.history.push('/login')
                      this.logoutProcess()
                    }}
                  >
                    <i className="ion ion-ios-log-out text-danger"></i> &nbsp; Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            <div className="demo-navbar-user align-self-center mr-1">
              <span className="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                <span className="px-1 mr-lg-2 ml-2 ml-lg-0">{this.props.user && this.genUserFullName()}</span>
              </span>
            </div>
            {/* logout */}
            <PowerIcon
              className="ion ion-ios-power navbar-icon align-middle "
              onClick={() => {
                // this.props.logout()
                // this.props.history.push('/login')
                this.logoutProcess()
              }}
            />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

LayoutNavbar.propTypes = {
  sidenavToggle: PropTypes.bool,
  onToggle: PropTypes.func,
}

LayoutNavbar.defaultProps = {
  sidenavToggle: true,
  onToggle: () => null,
}

export default connect(
  store => ({
    navbarBg: store.theme.navbarBg,
    user: store.authen.user ? store.authen.user : undefined,
    locale: store.theme.locale,
    pageTitle: store.theme.title,
    setting: store.theme,
  }),
  { setLanguage },
)(LayoutNavbarHoc)

const PowerIcon = styled.i`
  color: #cbf1e3;
  align-self: center;
  transition: transform 0.2s;

  &:hover {
    color: #ffffff;
    cursor: pointer;
    transform: scale(1.5);
  }
`
